export default "__VITE_ASSET__ByLNNEgP__"